module.exports = {
  keys: {
    encryption:
      process.env.PAGARME_ENCRYPTION_KEY ??
      process.env.VUE_APP_PAGARME_ENCRYPTION_KEY,
  },
}
